window.solutionFormHandler = () => {
  document.addEventListener('DOMContentLoaded', () => {
    inputRegionEvents();
    formValidationEvents();
  });

  const inputRegionEvents = () => {
    $('.jsSolutionFormSelect').select2({
      placeholder: 'Country/Region',
      minimumResultsForSearch: Infinity,
      dropdownCssClass: "solution-form__select-dropdown",
      width: '100%',
      tags: true,
    });

    // Select change
    $('.jsSolutionFormSelect').on('change', (e) => {
      const select = document.querySelector('.jsSolutionFormSelect');
      const label = select.parentElement;
      const error = label.querySelector('.jsSolutionFormError');
      error.innerText = '';
    });
  };

  const formValidationEvents = () => {
    const form = document.querySelector('.jsSolutionForm');
    const formFields = form.querySelectorAll('.jsSolutionFormField');
    const formSubmit = form.querySelector('.jsSolutionFormSubmit');
    const url = form.getAttribute('data-url');

    formSubmit.addEventListener('click', e => {
      e.preventDefault();
      const data = {};
      let formValid = true;

      formFields.forEach((field) => {
        const {id: name, type, value} = field.control;
        const error = field.querySelector('.jsSolutionFormError');

        if (type === "text" || type === "select-one") {
          if (value === "") {
            formValid = false;
            error.innerText = 'Wrong value!';
          } else {
            data[name] = value;
            error.innerText = '';
          }
        } else if (type === "email") {
          const regexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          if (value === "" || !regexp.test(value)) {
            formValid = false;
            error.innerText = 'Wrong value!';
          } else {
            data[name] = value;
            error.innerText = '';
          }
        }
      });

      if (formValid) {
        $.ajax({
          type: 'POST',
          url,
          data,
          beforeSend: () => {
            formSubmit.setAttribute('disabled', 'disabled');
          },
          complete: () => {
            formSubmit.removeAttribute('disabled');
            formSubmit.innerText = 'Submitted';

            setTimeout(() => {
              formSubmit.innerText = 'Submit';
            });
          },
          success: (data) => {
            formFields.forEach((field) => {
              const error = field.querySelector('.jsSolutionFormError');

              field.control.value = '';
              error.innerText = '';
              $('.jsSolutionFormSelect').val(null).trigger('change');
            });
          },
          error: (data) => {
            console.log('failure ' + data)
            formSubmit.removeAttribute('disabled');
          },
          headers: {
            'X-CSRFToken': getCookie('csrftoken')
          },
        });
      } else {
        console.warn('Form is invalid!');
      }
    });
  };
}
